import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import LoadingSpan from "@/components/LoadingSpan.vue";
import DebouncedInput from "@/components/DebouncedInput";
import CurrentUser from "@/components/providers/CurrentUser";
import UserHistories from "@/components/providers/UserHistories";
import MultipleViewList from "./MultipleViewList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleView',
    setup(__props) {
        const filter = ref("");
        //@ts-ignore bad library types
        library.add(faTimes);
        function updateFilter(newFilter) {
            filter.value = newFilter;
        }
        return { __sfc: true, filter, updateFilter, FontAwesomeIcon, LoadingSpan, DebouncedInput, CurrentUser, UserHistories, MultipleViewList };
    }
});
